import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class EventPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.eventRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.eventImport,
    );
    this.eventAutocomplete = permissionChecker.match(
      Permissions.values.eventAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.eventCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.eventEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.eventDestroy,
    );
  }
}
